//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      isOpen: true
    }
  },
  props: {
    index: Number,
    title: String,
    content: Array,
    productId: {
      type: String,
      default: ''
    },
    packageId: {
      type: String,
      default: ''
    },
    productInternalName: String,
    datasheet: Object,
    collapseAll: Boolean,
    expandAll: Boolean,
    buttonClicked: Boolean
  },
  methods: {
    collapseOpen () {
      this.isOpen = true
      this.$emit('toggle')
    },
    collapseClose () {
      this.isOpen = false
      this.$emit('toggle')
    }
  },
  computed: {
    isOpenFunc () {
      if (!this.buttonClicked) {
        return this.isOpen
      } else if (this.expandAll) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    collapseAll () {
      if (this.buttonClicked) {
        this.isOpen = (this.expandAll === true)
      }
    },
    expandAll () {
      if (this.buttonClicked) {
        this.isOpen = (this.expandAll === true)
      }
    }
  }
}
